import { Skeleton } from '@ethings/ui-toolkit';
import { isNumber } from 'lodash';
import { FC } from 'react';
import { useSpeedLimitQuery } from '../../hooks';
import { formatValue } from '../../util';
import { SpeedLimitProps } from './speed-limit.types';

export const SpeedLimit: FC<SpeedLimitProps> = ({
  heading,
  loadingElement = <Skeleton />,
  mode = 'car',
  notFoundElement = <></>,
  unit = 'metric',
  waypoints,
}) => {
  const { data: speedLimitKph, isLoading } = useSpeedLimitQuery({ waypoints, heading, mode });

  if (isLoading) return <>{loadingElement}</>;
  if (!isNumber(speedLimitKph)) return <>{notFoundElement}</>;

  return <>{formatValue(speedLimitKph, 'speed', unit)}</>;
};
